import { render, staticRenderFns } from "./ClientPreferences.vue?vue&type=template&id=20f4dc86&scoped=true&"
import script from "./ClientPreferences.vue?vue&type=script&lang=js&"
export * from "./ClientPreferences.vue?vue&type=script&lang=js&"
import style0 from "./ClientPreferences.vue?vue&type=style&index=0&id=20f4dc86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f4dc86",
  null
  
)

export default component.exports